import * as React from 'react';
import { Context } from '~/Router/Context';
export var useRouter = function () {
    var _a = React.useContext(Context), currentSubdomain = _a.subdomain, host = _a.host, protocol = _a.protocol;
    var buildLink = function (to, subdomain) {
        return subdomain === undefined || subdomain === currentSubdomain
            ? { isRelative: true, to: to }
            : {
                isRelative: false,
                to: "".concat(protocol, "//").concat(subdomain !== null ? "".concat(encodeURIComponent(subdomain), ".") : '').concat(host).concat(to),
            };
    };
    var redirect = function (to, subdomain, replace, data) {
        var link = buildLink(to, subdomain);
        if (link.isRelative) {
            if (replace !== null && replace !== void 0 ? replace : false) {
                history.replaceState(data, '', link.to);
            }
            else {
                history.pushState(data, '', link.to);
            }
        }
        else {
            window.location.assign(link.to);
        }
    };
    return [redirect, buildLink];
};
